<template>
  <div>
    <el-dialog title="" :visible.sync="visible" width="55%" top="10vh" :before-close="handleClose" z-index="99999">
      <div class="cha" @click="handleClose">
        <img src="@/assets/img/cha.png" alt="">
      </div>
      <!-- <img :src="info.image" alt="" class="dia_img"> -->
      <div class="dia_one modal-copy-width">{{info.title}}</div>
      <div class="dia_two modal-copy-width">“ {{info.description}} ”</div>
      <div class="dia_three modal-copy-width" v-html="info.content"></div>
    </el-dialog>
  </div>
</template>

<script>
  // Created by www.xingnuocn.com
  // @title: 详情
  // @author: 刘嘉鑫
  export default {
    props: {
      visible: Boolean,
      info: Object,
    },
    data() {
      return {
        dialogVisible: false
      }
    },
    mounted() { },
    methods: {
      handleClose(done) {
        this.$emit('closepop', 'visibleCode'); //通知父组件改变。
      },
    }
  }
</script>

<style scoped lang="scss">
  ::v-deep .el-dialog {
    border-radius: 40px;
  }

  ::v-deep .el-dialog__body {
    padding: 0 0 96px !important;
    border-radius: 40px;
    overflow: hidden;
  }

  ::v-deep .el-dialog__header {
    padding: 0 !important;
  }

  ::v-deep .el-dialog__headerbtn {
    display: none !important;
  }

  ::v-deep .el-dialog__wrapper {
    backdrop-filter: blur(15px);
  }


  .cha {
    position: absolute;
    top: 16px;
    right: 16px;
    background: #333336;
    border-radius: 50%;
    padding: 14px;
    cursor: pointer;

    img {
      width: 12px;
      height: 12px;
    }
  }

  .dia_img {
    width: 100%;
    height: auto;
  }

  .modal-copy-width {
    padding: 0 76px;
  }

  .dia_one {
    margin-top: 62px;
    font-size: 40px;
    line-height: 1;
    font-weight: 600;
    color: #2A303A;
    letter-spacing: 3px;
  }

  .dia_two {
    font-weight: 400;
    font-size: 20px;
    color: #5D6574;
    margin-top: 30px;
    letter-spacing: 2px;
  }

  .dia_three {
    margin-top: 60px;
    font-weight: 400;
    font-size: 20px;
    color: #5D6574;
    line-height: 40px;
    letter-spacing: 2px;
  }
</style>